import envConfig from "../config/config";

export const AppUrls = {
    signUp: "/users/register",
    login: "/users/login",
    adLogin: "/users/adlogin",
    devXLogin: "/adusers/login",
    categoriesList: "https://apihub-admin-eddad0g9fdgaeyd6.southindia-01.azurewebsites.net/apirepo/v0.1/category/categories",
    projectsList: "/projects",
    projectsListByID: "/projects/user/",
    projectDetails: "/project?id=",
    // projectDetails: "/apiProjectDetails",
    // projectDetails: "/project",
    projectLogo: `${envConfig.REACT_APP_APIREPO_WRITE}/apirepo/v0.1/project/logo`,
    swaggerFile: `${envConfig.REACT_APP_APIREPO_WRITE}/apirepo/v0.1/swaggerfile`,
    createProject: `${envConfig.REACT_APP_APIREPO_WRITE}/apirepo/v0.1/project`,
    addApiDetails: "/project/apidetail",
    pocList: "/pocs",
    pocListById: "/poc?id=",
    pocTechnologies: "/pocs/technologies",
    resTechnologies: "whitepaper/categories",
    readMeFile: "/poc/readme?id=",
    resTechnologiesWithCount: "whitepaper/count",
    resList: "/whitepapers",
    resListById: "/whitepapers/",
    shim: "/gatewayshim",
    shimData: "/gatewaydata",
    allApiList: "/apis",
    allapis: "/api",
    search: "search?",
    projectsCount: "/projectsCount",
    apisCount: "/buApiCount",
    hashTag: "/hashtag?",
    reviewRequest: "/project/status",
    generateToken: "/gateway/consumer/token",
    addWhitePaper: "/whitepaper",
    publisherWhitepapers: "/publisherWhitepapers/",
    whitePaperSearch: "/whitepapers/search?",
    addWhitePaperLogo: "/whitepaper/logo",
    updateWhitepaper: "/whitepaper/update",
    whitePaperCount: "/publisherDashboard/",
    metricsDetails: "/project/metrics?projectID=",
    whitePaperHash: "/whitepaper/hashtag?",
    producerAuth: "/gateway/plugin/producerauth?id=",
    demoLogin: "/users/login/demo",
    generateDesc: "/swaggerfile/generateDescription",
    refreshToken: "/auth/refresh-token",

    // Admin End Points
    adminDashboard: "/admin/dashboard",
    buDashBoardCount: "/admin/BU/dashboard?BU=",
    viewAllProjects: "/admin/projects",
    adminProjects: "/projects",
    viewAllUsers: "/admin/users?role=",
    buAdminUser: "/admin/BU/users?",
    deleteUser: "/admin/user/delete",
    changeRole: "/admin/request/create",
    apiCalls: "/apis/details",
    adminSearch: "/admin/search?searchData=",
    admin_BU_Search: "/admin/searchBU?searchData=",
    apiConsumption: "/data/consumption",
    apiValidation: "/admin/api/validation",
};